

document.addEventListener('on:cart-drawer:before-open', (event) => {
  var trustedBadge = document.querySelector('[id^="trustbadge-container-"]');
  trustedBadge.style.display = "none";
});

document.addEventListener('on:cart-drawer:after-close', (event) => {
  var trustedBadge = document.querySelector('[id^="trustbadge-container-"]');
  trustedBadge.style.display = "block";
});

document.addEventListener('on:cart-drawer:before-open', (event) => {
  var shopChatIcon = document.querySelector('[id^="shopify-chat"]');
  shopChatIcon.style.display = "none";
});

document.addEventListener('on:cart-drawer:after-close', (event) => {
  var shopChatIcon = document.querySelector('[id^="shopify-chat"]');
  shopChatIcon.style.display = "block";
});
